export default function minifyCSSString(style) {
  return style.replace(/\s{2,}/g, '');
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/style-container/node_modules/fela/es/minifyCSSString.js
// module id = 1088
// module chunks = 0